document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Barra de progresso de scroll ---------- */
  var progressBar = document.getElementById('vlm-scroll-progress');
  if (progressBar) {
    window.addEventListener('scroll', function () {
      var h = document.documentElement;
      var scrolled = (h.scrollTop) / (h.scrollHeight - h.clientHeight) * 100;
      progressBar.style.width = scrolled + '%';
    }, { passive: true });
  }

  /* ---------- Cursor personalizado ---------- */
  var cursor = document.getElementById('vlm-cursor');
  if (cursor && window.matchMedia('(pointer: fine)').matches) {
    var cx = 0, cy = 0, dx = 0, dy = 0;
    document.addEventListener('mousemove', function (e) {
      cx = e.clientX; cy = e.clientY;
      cursor.style.opacity = 1;
    });
    function animateCursor() {
      dx += (cx - dx) * 0.18;
      dy += (cy - dy) * 0.18;
      cursor.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      requestAnimationFrame(animateCursor);
    }
    animateCursor();

    document.querySelectorAll('a, button, .vlm-product__thumb, summary').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursor.classList.add('is-hover'); });
      el.addEventListener('mouseleave', function () { cursor.classList.remove('is-hover'); });
    });
  }

  /* ---------- Botões magnéticos ---------- */
  document.querySelectorAll('.vlm-btn').forEach(function (btn) {
    btn.addEventListener('mousemove', function (e) {
      var rect = btn.getBoundingClientRect();
      var relX = e.clientX - rect.left - rect.width / 2;
      var relY = e.clientY - rect.top - rect.height / 2;
      btn.style.transform = 'translate(' + relX * 0.25 + 'px,' + relY * 0.35 + 'px)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.transform = 'translate(0,0)';
    });
  });

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.vlm-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, (entry.target.dataset.revealDelay || 0));
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Contadores animados ---------- */
  document.querySelectorAll('[data-vlm-count]').forEach(function (el) {
    var raw = el.dataset.vlmCount;
    var match = raw.match(/[\d.,]+/);
    if (!match) return;
    var target = parseFloat(match[0].replace(/,/g, ''));
    var prefix = raw.slice(0, match.index);
    var suffix = raw.slice(match.index + match[0].length);
    var started = false;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !started) {
          started = true;
          var start = null;
          var duration = 1400;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = Math.floor(eased * target);
            el.textContent = prefix + current.toLocaleString('en-US') + suffix;
            if (progress < 1) requestAnimationFrame(step);
            else el.textContent = raw;
          }
          requestAnimationFrame(step);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(el);
  });

  /* ---------- Tilt 3D em imagens de produto ---------- */
  document.querySelectorAll('.vlm-tilt').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width - 0.5;
      var py = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(1000px) rotateY(' + (px * 10) + 'deg) rotateX(' + (py * -10) + 'deg)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = 'perspective(1000px) rotateY(0) rotateX(0)';
    });
  });
});
